"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveEmailDefaultOwnerPropertyValues = exports.saveEmailDefaultCompanyPropertyValues = exports.saveEmailDefaultContactPropertyValues = exports.SaveChanges = exports.SaveChangesActionTypes = exports.saveChanges = exports.SaveActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var SaveActionTypes = (0, _namespacedKeyMirror.default)({
  SAVE_CHANGES: null,
  SAVE_DEFAULT_CONTACT_PROPERTY_VALUES: null,
  SAVE_DEFAULT_COMPANY_PROPERTY_VALUES: null,
  SAVE_DEFAULT_OWNER_PROPERTY_VALUES: null
}, 'email');
exports.SaveActionTypes = SaveActionTypes;
var saveChanges = (0, _fluxActions.createAction)(SaveActionTypes.SAVE_CHANGES);
exports.saveChanges = saveChanges;
var SaveChangesActionTypes = (0, _actions.createRequestTypes)(SaveActionTypes.SAVE_CHANGES);
exports.SaveChangesActionTypes = SaveChangesActionTypes;
var SaveChanges = (0, _actions.createRequestActions)(SaveChangesActionTypes);
exports.SaveChanges = SaveChanges;
var saveEmailDefaultContactPropertyValues = (0, _fluxActions.createAction)(SaveActionTypes.SAVE_DEFAULT_CONTACT_PROPERTY_VALUES);
exports.saveEmailDefaultContactPropertyValues = saveEmailDefaultContactPropertyValues;
var saveEmailDefaultCompanyPropertyValues = (0, _fluxActions.createAction)(SaveActionTypes.SAVE_DEFAULT_COMPANY_PROPERTY_VALUES);
exports.saveEmailDefaultCompanyPropertyValues = saveEmailDefaultCompanyPropertyValues;
var saveEmailDefaultOwnerPropertyValues = (0, _fluxActions.createAction)(SaveActionTypes.SAVE_DEFAULT_OWNER_PROPERTY_VALUES);
exports.saveEmailDefaultOwnerPropertyValues = saveEmailDefaultOwnerPropertyValues;